export const defaultViewPort = {
    latitude: -29,
    longitude: 133,
    zoom: 3.125,
    minZoom: 2,
    bearing: 0,
    pitch: 0
  };